// Install MUI by running the following command:
// npm install @mui/material @emotion/react @emotion/styled
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Card, CardContent, Grid, Typography, Box, ListItem, Container, Divider, Dialog } from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import DummyHouse from 'assets/images/uploadHistory.jpg';
import { useDispatch } from 'react-redux';
import { ListingActions } from 'store/slices/listings';
import { ENVIRONMENT } from './config';
import { TransformWrapper, TransformComponent, useControls } from 'react-zoom-pan-pinch';

const Controls = () => {
    const { zoomIn, zoomOut, resetTransform } = useControls();

    return (
        <div className="tools">
            <button onClick={() => zoomIn()}>+</button>
            <button onClick={() => zoomOut()}>-</button>
            <button onClick={() => resetTransform()}>x</button>
        </div>
    );
};

export default function ListingData({ data, propertyId }) {
    const dispatch = useDispatch();
    const { createShotnerURL } = ListingActions;

    const [tinyUrl, setTinyUrl] = useState({});
    const [tinyUrlAgent, setTinyUrlAgent] = useState({});

    useEffect(() => {
        if (data) {
            if (data?.howToApply?.websiteAppLinkPublicView) {
                const publicUrl = data.howToApply.websiteAppLinkPublicView;
                dispatch(createShotnerURL({ url: publicUrl, property_id: propertyId })).then((res) => {
                    if (res?.payload) {
                        setTinyUrl(res?.payload);
                    }
                });
            }
            if (data?.howToApply?.websiteAppLinkAgentView) {
                const privateUrl = data.howToApply.websiteAppLinkAgentView;
                dispatch(createShotnerURL({ url: privateUrl, property_id: propertyId })).then((res) => {
                    if (res?.payload) {
                        setTinyUrlAgent(res?.payload);
                    }
                });
            }
        }
    }, [data]);

    const isNumber = (value) => typeof value === 'number' && !Number.isNaN(value);

    const totalVisits = () => {
        const tinyUrlCount = isNumber(tinyUrl?.visitsCount) ? tinyUrl.visitsCount : null;
        const tinyUrlAgentCount = isNumber(tinyUrlAgent?.visitsCount) ? tinyUrlAgent.visitsCount : null;

        if (tinyUrlCount !== null && tinyUrlAgentCount !== null) {
            return tinyUrlCount + tinyUrlAgentCount;
        } else if (tinyUrlCount !== null) {
            return tinyUrlCount;
        } else if (tinyUrlAgentCount !== null) {
            return tinyUrlAgentCount;
        }
        return 0;
    };

    const [selectedImage, setSelectedImage] = useState(null);
    const [open, setOpen] = useState(false);
    const handleClickOpen = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <TransformWrapper initialScale={1}>
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                        <>
                            <Controls />
                            <TransformComponent>
                                <img src={selectedImage} style={{ width: '100%', height: '100%', objectFit: 'fit' }} alt="Full View" />
                            </TransformComponent>
                        </>
                    )}
                </TransformWrapper>
            </Dialog>
            <Card style={{ maxWidth: 1200, marginTop: 30 }}>
                <Grid container spacing={10} sx={{ margin: 'unset', width: '100%' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            {data?.attachments?.length <= 0 && (
                                <img src={DummyHouse} alt="Listing1" style={{ width: '100%', objectFit: 'fit' }} />
                            )}
                            <Carousel showThumbs={false}>
                                {data?.attachments?.map((e, index) => (
                                    <div
                                        key={index}
                                        style={{ width: '100%', height: '300px' }}
                                        onClick={() =>
                                            handleClickOpen(
                                                ENVIRONMENT === 'TESTING'
                                                    ? `https://mls-development-bucket.s3.us-east-1.amazonaws.com/${e?.url}`
                                                    : `https://mls-production-data.s3.us-east-1.amazonaws.com/${e?.url}`
                                            )
                                        }
                                    >
                                        <img
                                            src={
                                                ENVIRONMENT === 'TESTING'
                                                    ? `https://mls-development-bucket.s3.us-east-1.amazonaws.com/${e?.url}`
                                                    : `https://mls-production-data.s3.us-east-1.amazonaws.com/${e?.url}`
                                            }
                                            alt="Listing1"
                                            style={{ width: '100%', height: '100%', objectFit: 'fit' }}
                                            onError={(event) => {
                                                event.target.src =
                                                    'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLyjrivqzSKLbfF5q8NmGBO8Q84N6ZK1kH_A&s';
                                            }}
                                        />
                                    </div>
                                ))}
                            </Carousel>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <CardContent>
                                {/* The address should be in the following order:
                                    “Street Number” + “ Street Name” + “Street Type/Suffix” + “Unit
                                    Number” + “City” + “State” + “Zip Code” */}
                                <Typography variant="h5" component="div" sx={{ textTransform: 'capitalize', fontWeight: '600' }}>
                                    {`${data?.locationInformation?.streetNumber ?? ''} ${data?.locationInformation?.streetName ?? ''} ${
                                        data?.locationInformation?.streetTypeOrSuffix
                                            ? data?.locationInformation?.streetTypeOrSuffix + ','
                                            : ''
                                    } ${data?.locationInformation?.unit ? `#${data?.locationInformation?.unit}` : ''} ${
                                        data?.locationInformation?.city ? data?.locationInformation?.city + ',' : ''
                                    } ${data?.locationInformation?.state ? data?.locationInformation?.state + ',' : ''} ${
                                        data?.locationInformation?.zipCode ?? ''
                                    } `}
                                </Typography>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'start',
                                        marginTop: '10px'
                                    }}
                                >
                                    {data?.listing_id && (
                                        <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                                            Listing ID: {`${data?.listing_id}`}
                                        </Typography>
                                    )}

                                    {data?.locationInformation?.unit && (
                                        <Typography variant="subtitle1" color="textSecondary" gutterBottom sx={{ marginRight: 2 }}>
                                            Unit ID: {`${data?.locationInformation?.unit}`}
                                        </Typography>
                                    )}
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                                        List Price: {`$${Number(data?.listingInformation?.listPrice ?? '').toLocaleString()}`}
                                    </Typography>

                                    <Typography variant="subtitle1" color="textSecondary" gutterBottom sx={{ marginRight: 2 }}>
                                        Total Visits: {`${totalVisits().toLocaleString()}`}
                                    </Typography>
                                </Box>
                                <Divider style={{ margin: '10px 0' }} />
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="body2" component="div">
                                            <strong>City:</strong> {data?.locationInformation?.city}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Country:</strong> {data?.locationInformation?.country}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>County:</strong> {data?.locationInformation?.county}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Property Type:</strong> {data?.generalInformation?.propertySubType}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong># Beds:</strong> {data?.generalInformation?.mainLevelBedrooms}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong># Baths:</strong> (Full:{data?.generalInformation?.bathroomsFull} /Half:
                                            {data?.generalInformation?.bathroomsHalf})
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Year Built:</strong> {data?.generalInformation?.yearBuilt}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Living SqFt:</strong> {data?.generalInformation?.livingArea} SqFt
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Lot Dimensions:</strong> {data?.generalInformation?.lotDimensions}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Lot Features:</strong> {data?.generalInformation?.lotFeatures?.join(', ')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Typography variant="body2" component="div">
                                            <strong>Garage Space:</strong> {data?.generalInformation?.garageSpaces}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Parking Feature:</strong> {data?.generalInformation?.parkingFeatures?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Roof:</strong> {data?.generalInformation?.roof?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Flooring:</strong> {data?.generalInformation?.flooring?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Pool:</strong> {data?.additionalInformation?.privatePoolFeatures?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>View:</strong> {data?.generalInformation?.view?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Heating:</strong> {data?.documentsAndUtilities?.heating?.join(', ')}
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            <strong>Cooling:</strong> {data?.documentsAndUtilities?.cooling?.join(', ')}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Grid>
                    </Grid>

                    {data?.specialUserAccess?.length > 0 && (
                        <Grid container spacing={2} sx={{ margin: 'unset', width: '100%' }}>
                            <Typography variant="h3" component="div">
                                Listing Access Information
                            </Typography>
                            <Grid container spacing={2}>
                                {data?.specialUserAccess?.map((item, index) => (
                                    <Grid item xs={12} sm={4} key={index}>
                                        <Card>
                                            <CardContent>
                                                {item.user.roleName === 'REGIONAL_MANAGER' ||
                                                item.user?.roleName === 'MARKETING_MANAGER' ? (
                                                    <Typography variant="h6" color="primary">
                                                        {item.user.roleName === 'REGIONAL_MANAGER'
                                                            ? 'REGIONAL MANAGER'
                                                            : 'MARKETING MANAGER'}
                                                    </Typography>
                                                ) : (
                                                    <Typography variant="h6" color="secondary">
                                                        APARTMENT MANAGER
                                                    </Typography>
                                                )}
                                                <Typography variant="body1">Name: {item.user.firstName}</Typography>
                                                <Typography variant="body2">Email: {item.user.email}</Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    )}

                    <Grid container spacing={2} sx={{ margin: 'unset', width: '100%' }}>
                        <Typography variant="h3" component="div">
                            General Information
                        </Typography>
                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Complex Name:</strong> {data?.generalInformation?.complexName}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Builder Name:</strong> {data?.generalInformation?.builderName}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Floor Plan Name:</strong> {data?.generalInformation?.floorPlanName}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Living Area:</strong> {data?.generalInformation?.livingArea}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Parking Total:</strong> {data?.generalInformation?.parkingTotal}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Water Front Features:</strong> {data?.generalInformation?.waterfrontFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Construction Materials:</strong> {data?.generalInformation?.constructionMaterials?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Appliances:</strong> {data?.additionalInformation?.appliances?.join(', ')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Interior:</strong> {data?.additionalInformation?.interiorFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Exterior:</strong> {data?.additionalInformation?.exteriorFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Appliances:</strong> {data?.additionalInformation?.appliances?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Community Features:</strong> {data?.additionalInformation?.communityFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong># Fireplace:</strong> {data?.additionalInformation?.fireplaces}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Fireplace Features:</strong> {data?.additionalInformation?.fireplaceFeatures?.join(', ')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Accessibility Features:</strong>{' '}
                                    {data?.additionalInformation?.accessibilityFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Security Features:</strong> {data?.additionalInformation?.securityFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Horse Amenities:</strong> {data?.additionalInformation?.horseAmenities?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Laundry Location:</strong> {data?.additionalInformation?.laundryLocation?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Private Pool Features:</strong> {data?.additionalInformation?.privatePoolFeatures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Window Features:</strong> {data?.additionalInformation?.windowFeatures?.join(', ')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Divider style={{ margin: '10px 0' }} />

                    <Grid container spacing={2} sx={{ margin: 'unset', marginTop: 5, width: '100%' }}>
                        <Typography variant="h3" component="div">
                            Utility Information
                        </Typography>
                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" component="div">
                                    <strong>Heating:</strong> {data?.documentsAndUtilities?.heating?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Cooling:</strong> {data?.documentsAndUtilities?.cooling?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Disclosures:</strong> {data?.documentsAndUtilities?.disclosures?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Documents Available:</strong> {data?.documentsAndUtilities?.documentsAvailable?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Owner Pays:</strong> {data?.documentsAndUtilities?.ownerPays?.join(', ')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2" component="div">
                                    <strong>Tenant Pays:</strong> {data?.documentsAndUtilities?.tenantPays?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Utlities:</strong> {data?.documentsAndUtilities?.utilities?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Sewer:</strong> {data?.documentsAndUtilities?.sewer?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Water Source:</strong> {data?.documentsAndUtilities?.waterSource?.join(', ')}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Divider style={{ margin: '10px 0' }} />

                    <Grid container spacing={2} sx={{ margin: 'unset', marginTop: 5, width: '100%' }}>
                        <Typography variant="h3" component="div" gutterBottom>
                            How to Apply
                        </Typography>
                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Managed By:</strong> {data?.howToApply?.managedBy}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Application Fee:</strong> {data?.howToApply?.applicationFee}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Application Fee Payable To:</strong> {data?.howToApply?.applicationFeePayableTo}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Security Deposit:</strong> {data?.howToApply?.securityDeposit}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Security Deposit Payable To:</strong> {data?.howToApply?.securityDepositPayableTo}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Pets Allowed:</strong> {data?.howToApply?.petAllowed?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Pet Deposit:</strong> {data?.howToApply?.petDeposit}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Pet Deposit Per Pet:</strong> {data?.howToApply?.petDepositPerPet}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Administration Fee:</strong> {data?.howToApply?.administrationFee}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Administration Fee Payable To:</strong> {data?.howToApply?.administrationFeePayableTo}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>First Month Rent Payable To:</strong> {data?.howToApply?.firstMonthRentPayableTo}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Recurring Expense:</strong> {data?.howToApply?.recurringExpense?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>One Time Expense:</strong> {data?.howToApply?.oneTimeExpense?.join(', ')}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Lease Term:</strong> {data?.howToApply?.leaseTerm}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Lease Guarantor:</strong> {data?.howToApply?.leaseGuarantorYN}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Certified Funds:</strong> {data?.howToApply?.certifiedFunds}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Application Policy:</strong> {data?.howToApply?.applicationPolicy}
                                </Typography>
                                {data?.howToApply?.availableDate && (
                                    <Typography variant="body2" component="div">
                                        <strong>Available Date:</strong>{' '}
                                        {new Date(data?.howToApply?.availableDate).toLocaleDateString('en-US', {
                                            year: '2-digit',
                                            month: '2-digit',
                                            day: '2-digit'
                                        })}
                                    </Typography>
                                )}
                                <Typography variant="body2" component="div">
                                    <strong>Owner Contribution:</strong> {data?.howToApply?.sellerContributionYN}
                                </Typography>
                                {tinyUrl?.id && (
                                    <Typography variant="body2" component="div">
                                        <strong>Website App Link Public View:</strong>{' '}
                                        <a target="_blank" rel="noreferrer" href={`https://mlsapartments.com/r?id=${tinyUrl?.id}`}>
                                            {`https://mlsapartments.com/r?id=${tinyUrl?.id}`}
                                        </a>
                                    </Typography>
                                )}
                                {tinyUrlAgent?.id && (
                                    <Typography variant="body2" component="div">
                                        <strong>Website App Link Agent View:</strong>{' '}
                                        <a target="_blank" rel="noreferrer" href={`https://mlsapartments.com/r?id=${tinyUrlAgent?.id}`}>
                                            {`https://mlsapartments.com/r?id=${tinyUrlAgent?.id}`}
                                        </a>
                                    </Typography>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ margin: 'unset', marginTop: 5, width: '100%' }}>
                        <Typography variant="h3" component="div" gutterBottom>
                            Showing Information
                        </Typography>
                        <Grid container spacing={2} marginTop={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Owner Name:</strong> {data?.showingInformation?.ownerName}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Occupant Type:</strong> {data?.showingInformation?.occupantType}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Lockbox Type:</strong>
                                    {data?.showingInformation?.lockboxType}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Lockbox Location:</strong> {data?.showingInformation?.lockboxLocation}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Lockbox Serial Number:</strong>
                                    {data?.showingInformation?.lockboxSerialNumber}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Management Company:</strong>
                                    {data?.showingInformation?.managementCompany}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Management Company Phone:</strong>
                                    {data?.showingInformation?.managementCompanyPhone}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Showing Contact Name:</strong>
                                    {data?.showingInformation?.showingContactName}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Showing Contact Phone:</strong>
                                    {data?.showingInformation?.showingContactPhone}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Showing Service Phone:</strong>
                                    {data?.showingInformation?.showingServicePhone}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Showing Requirements:</strong>
                                    {data?.showingInformation?.showingRequirements?.join(', ')}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Showing Instructions:</strong>
                                    {data?.showingInformation?.showingInstructions}
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant="body2" component="div">
                                    <strong>Directions:</strong> {data?.remarksInformation?.directions}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Public Remarks:</strong> {data?.remarksInformation?.publicRemarks}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Private Remarks:</strong> {data?.remarksInformation?.privateRemarks}
                                </Typography>
                                <Typography variant="body2" component="div">
                                    <strong>Syndication Remarks:</strong> {data?.remarksInformation?.syndicationRemarks}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
        </>
    );
}
